module.exports = __webpack_public_path__ + "img/home.ff26ed2e.svg";